import React, { Component } from 'react';
import {  Button , Container , Confirm , Dimmer , Dropdown, Form,  Grid , Header , Icon ,Input ,  Label, Loader , Message , Modal , Popup , Segment , Table , TextArea  ,  Progress  } from 'semantic-ui-react'; 
import * as constantes from '../../constantes';
import { useParams , Link } from 'react-router-dom';

import auth0Client from '../Auth/Auth'; 
const server = constantes.REST_API_PRIVATE;
const serverPu = constantes.REST_API_PUBLIC;

const tipoResultadoOption = [
    { key: '1', text: 'CONTINUAR', value: 1 },
    { key: '2', text: 'IMPROCEDENTE_DEMANDA', value: 2 },
    { key: '3', text: 'IMPROCEDENTE_RAC', value: 3 },
    { key: '4', text: 'NULO_CONCESORIO', value: 4 },
    { key: '5', text: 'NULO_ADMITASE', value: 5 },
    { key: '6', text: 'NULO_CALIFICAR', value: 6 },
    { key: '7', text: 'FUNDADA', value: 7 },
    { key: '8', text: 'INFUNDADA', value: 8 },
    { key: '9', text: 'RECHAZADO_RAC', value: 9 } 
]

//Algunos de los valores configurados para RECHAZO INMEDIATO no generan un resultado RESOLUTORIO inmediatamente pese a tener configurada esa funcion.
//Esto es Debido a que se ha configurado que para esas respuesta se muestren algunas opciones para que recien seleccione el usuario como proceder. 
const tipoRechazoOption = [
    { key: '0', value: '0' , text: 'CONTINUAR'},
    { key: '1', value: '1' , text: 'IMPROCEDENTE'},
    { key: '2', value: '2' , text: 'NULO'} ,
    { key: '5', value: '5' , text: 'NULO TODO LO ACTUADO'}, //CONTINUAR
    { key: '6', value: '6' , text: 'NULO - ADMITASE'}, //MUESTRA CHECKLIST DE ADMISIBILIDAD
    { key: '7', value: '7' , text: 'FUNDADA'},
    { key: '8', value: '8' , text: 'INFUNDADA'},
    { key: '9', value: 'true' , text: 'Verdadero'},
    { key: '10', value: 'false' , text: 'Falso'},
]

const emptyResolucionRacsTemplate = {
    resolucionRacId : null,
    consecuencia : '',
    motivo : '',
    tipoRechazo : null,
    tipoResultado : null,
    estado : 1,
    usuarioCreacion : null,
    usuarioModificacion : null,
    fechaCreacion : null,
    fechaModificacion : null,
    tempAlternativaId : null,
}

const WrappedResultados = props => {
   
    const params = useParams()

    return <Resultado id={params.id} />
}

const emptyPlantilla = { 
    resolucionRacPlantillaId : null , 
    resolucionRac : { resolucionRacId : null } , 
    codigo : '' , 
    nombre : '' , 
    link : '' , 
    tienePlantillaDocx : 0 
};

class Resultado extends Component{

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            error: null,
            errors: [],
            mensaje : '',
            error2 : '' ,

            preguntaId : props.id,
            listaPlantillas: [],
            resolucionRac : null,

            showModalEdit:false ,
            showPanelPlantillas:false ,
            showModalPlantillaEdit:false ,
            tempPlantilla : emptyPlantilla,
            tempResolucionRac : emptyResolucionRacsTemplate,

            confirmEliminarRacOpen :false,
            resolucionRacIdDelete : null, 
            dimmerEliminarRac : false , 
            optlistaAlternativas : [] ,

            showModalWord:false,
            resolucionRacPlantillaId_word : null ,
            up_file: null,
            up_fileName: "",
            up_isUploading: false,
            up_statusCode: ""

        };
  
        this.nuevoResultado = this.nuevoResultado.bind(this);
        this.setShowModalEdit =this.setShowModalEdit.bind(this) ;         
        this.editarResolucionRac = this.editarResolucionRac.bind(this);
        this.cargarListaResultados = this.cargarListaResultados.bind(this);

        this.verPlantillas = this.verPlantillas.bind(this);
        this.setShowPanelPlantillas =this.setShowPanelPlantillas.bind(this) ;
        this.nuevaPlantilla = this.nuevaPlantilla.bind(this);
        //this.registrarPlantilla = this.registrarPlantilla.bind(this);
        
        this.setShowModalPlantillaEdit = this.setShowModalPlantillaEdit.bind(this);
        //handleChangeBoolean
        this.eliminarResolucionRac = this.eliminarResolucionRac.bind(this);
        this._handlerChangeTextResolucionObject = this._handlerChangeTextResolucionObject.bind(this);
        this._onChangeSelectResolucionObject = this._onChangeSelectResolucionObject.bind(this);
        
    }
  
    componentDidMount() {
        let METHODNAME = 'componentDidMount - ';
        console.log(METHODNAME + 'INI');
        
        auth0Client.isExpired();

        //PARA MODAL DE PLANTILLA  
        this.setState({
            tempPlantilla: emptyPlantilla,
            confirmEliminarRacOpen : false 
        });

        this.cargarListaResultados( this.state.preguntaId );

    }
  
    async cargarListaResultados( preguntaId ){
        let METHODNAME = 'cargarListaResultados - ';
        console.log(METHODNAME + 'INI');

        const { optlistaAlternativas } = this.state;

        let url = server+`/preguntas/` + preguntaId + `/resultados`;
        
        fetch( 
            url , {
            method: 'GET',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            } 
        })
        .then(res => res.json())
        .then(
            
            (result) => {
                
                result.listaResolucionRac.map( 
                    ( tipo ) => {
                        tipo.tipoRechazoDesc = this.getTipoRechazoDesc( tipo.tipoRechazo )
                    }
                );

                this.setState({
                    isLoaded: true,
                    listaResolucionRac: result.listaResolucionRac,
                    pregunta : result.pregunta,
                });

                result.pregunta.alternativas.forEach(function(obj) {
                    optlistaAlternativas.push( { key: obj.alternativaId , text: obj.label , value: obj.alternativaId } ); 
                });
    
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )
        console.log(METHODNAME + 'FIN');
    }

    getTipoRechazoDesc( tipoRechazo ) {
        if( tipoRechazo ){
            let resultado = tipoRechazoOption.filter( tipo => tipo.value === tipoRechazo );
            return resultado[0] ? resultado[0].text : '-';
        }
        return '';
    }
 
    nuevoResultado(){
        let METHODNAME = 'nuevoResultado - ';
        console.log(METHODNAME + 'INI.' );
        
        this.setState({ 
            tempResolucionRac : emptyResolucionRacsTemplate,
            showModalEdit : true ,
            error2 : ''
        }); 
  
    }
  
    editarResolucionRac( resolucionRacId ){
        let METHODNAME = 'editarResolucionRac - ';
        console.log(METHODNAME + 'INI id = ' + resolucionRacId  );
        
        this.setState({ 
            showModalEdit : false ,
            tempResolucionRac : emptyResolucionRacsTemplate,
            error2 : '' 
        }); 

        //cargar los datos obtenidos 
        let url = server+`/resolucionRac/${resolucionRacId}` ;
        
        fetch( 
            url , {
            method: 'GET',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            } 
        })
        .then(res => res.json())
        .then(
            
            (result) => {
                console.log(METHODNAME + 'RESULTADO ok ');
                
                this.setState({
                    isLoaded: true,
                    showModalEdit : true ,
                    tempResolucionRac : {
                        resolucionRacId : result.resolucionRac.resolucionRacId,
                        consecuencia : result.resolucionRac.consecuencia,
                        motivo : result.resolucionRac.motivo,
                        modelo : result.resolucionRac.modelo,
                        tipoRechazo : result.resolucionRac.tipoRechazo,
                        tipoResultado : result.resolucionRac.tipoResultado?result.resolucionRac.tipoResultado.id:null,
                        estado : result.resolucionRac.estado,
                        usuarioCreacion : result.resolucionRac.usuarioCreacion,
                        usuarioModificacion : result.resolucionRac.usuarioModificacion,
                        fechaCreacion : result.resolucionRac.fechaCreacion,
                        fechaModificacion : result.resolucionRac.fechaModificacion,
                    } 
                });
    
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )

    }

    handleDetail( resultado ){
      let METHODNAME = 'handleDetail - ';
      console.log(METHODNAME + 'INI');
  
      console.log(METHODNAME + 'Resultado Id = ' + resultado.idResultadoRac );
  
      console.log(METHODNAME + 'FIN');
    }
  
    registrarResultado(){
        let METHODNAME = 'registrarResultado - ';
        console.log(METHODNAME + 'INI');

        if( this.state.tempResolucionRac.consecuencia.length == 0 || 
                this.state.tempResolucionRac.motivo.length == 0 || 
                    !this.state.tempResolucionRac.tipoRechazo ){
            this.setState({
                isLoaded: true, 
                showModalEdit : false ,
                error2:'Debe completar todos los campos'
            });
            return;
        }

        if( !this.state.tempResolucionRac.tipoResultado ){
            if( this.state.tempResolucionRac.tipoRechazo!= 9 && this.state.tempResolucionRac.tipoRechazo!= 10){
                this.setState({
                    isLoaded: true, 
                    showModalEdit : false ,
                    error2:'Si es que no selecciona un Tipo de Resultado, en el campo Tipo de Rechazo solo puede seleccionar las opciones Verdadero o Falso'
                });
                return;
            }
        }

        let url = server+`/resolucionRac/` ;
        
        let dataForm = {
            authUsername : localStorage.getItem('usuario'), 
            resolucionRac : { 
                resolucionRacId : this.state.tempResolucionRac.resolucionRacId,
                consecuencia : this.state.tempResolucionRac.consecuencia , 
                motivo : this.state.tempResolucionRac.motivo,
                modelo : this.state.tempResolucionRac.modelo,
                tipoRechazo : this.state.tempResolucionRac.tipoRechazo,
                tipoResultado : {
                    id : this.state.tempResolucionRac.tipoResultado
                },
                pregunta : {
                    idPregunta : this.state.preguntaId 
                },
                alternativaId :this.state.tempResolucionRac.tempAlternativaId ,
                estado : 1,
                usuarioCreacion : this.state.tempResolucionRac.usuarioCreacion,
                usuarioModificacion : this.state.tempResolucionRac.usuarioModificacion,
                fechaCreacion : this.state.tempResolucionRac.fechaCreacion,
                fechaModificacion : this.state.tempResolucionRac.fechaModificacion,
            } 
        }

        console.log( 'FORM = ' + JSON.stringify(dataForm) );


      fetch( 
          url , {
          method: 'POST',
          headers:{
              'Accept':'application/json',
              'Content-Type':'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
          } ,
          body:JSON.stringify(dataForm)
      })
      .then(res => res.json())
      .then(
          
          (result) => {

            if( result.resultado === 'true' ){
                console.log(METHODNAME + 'RESULTADO correcto');
                this.setState({
                    isLoaded: true, 
                    showModalEdit : false ,
                    tempResolucionRac : emptyResolucionRacsTemplate,
                });
                this.cargarListaResultados( this.state.preguntaId );
            }else{
                console.warn(METHODNAME +  'No se pudo eliminar ' );
                console.warn(METHODNAME +  'error : ' + result.error );

                this.setState({
                    isLoaded: true, 
                    showModalEdit : false ,
                    error2:result.error
                });
            }

          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
              console.log(METHODNAME + 'error = ' + error );
              this.setState({
                  isLoaded: true,
                  error
              });
          }
        )
        console.log(METHODNAME + 'FIN');
  
    }
    
    verPlantillas( resolucionRacId ){
        let METHODNAME = 'verPlantillas - ';
        console.log(METHODNAME + 'INI');

        this.setState({ 
            error2 : '' , 
        });

        let url = server+`/resolucionRac/` + resolucionRacId + `/plantillas`;
        
        fetch( 
            url , {
            method: 'GET',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            } 
        })
        .then(res => res.json())
        .then(
            
            (result) => {
                console.log(METHODNAME + 'LISTA DE PLANTILLAS PARA RESOLUCION RAC ' +resolucionRacId );
               
                this.setState({
                    isLoaded: true,
                    listaPlantillas: result.listaResolucionRacPlantillas,
                    resolucionRac : result.resolucionRac,
                    showPanelPlantillas : true 
                }); 
                //this.setShowPanelPlantillas( true );

            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )
        console.log(METHODNAME + 'FIN');

    }
    
    preEeliminarResolucionRac( resolucionRacId ){
        let METHODNAME = 'preEeliminarResolucionRac - ';
        console.log( METHODNAME + 'INI');
        this.setState({
            error2 : '' ,
            confirmEliminarRacOpen: true , 
            resolucionRacIdDelete : resolucionRacId ,
            dimmerEliminarRac :  false 
        });
        console.log( METHODNAME + 'FIN');
    }

    async eliminarResolucionRac(){
        let METHODNAME = 'eliminarResolucionRac - ';
        console.log( METHODNAME + 'INI ');
   
        if( this.state.resolucionRacIdDelete == null){
            console.log('No hay ID de resolucionRac para eliminar');
            return;
        }

        this.setState({ 
            error2 : '' ,
            dimmerEliminarRac : true  
        });

        let url =  `${server}/resolucionRac/${this.state.resolucionRacIdDelete}/`;
        let dataForm = {
            authUsername : localStorage.getItem('usuario'),
        }
        const json = await fetch( url , {
            method: 'DELETE',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            } ,
            body:JSON.stringify(dataForm)
        }).then((result) => {
           
            result.json().then((resp) => {

                if( resp.resultado === 'true' ){
                    console.warn(METHODNAME +  'eliminado correctamente.' );
                    
                    this.setState({
                        resolucionRacIdDelete : null , 
                        confirmEliminarRacOpen : false , 
                        dimmerEliminarRac : false  ,
                        showPanelPlantillas : false , 
                    });

                    this.cargarListaResultados( this.state.preguntaId );

                }else{
                    console.warn(METHODNAME +  'No se pudo eliminar ' );
                    console.warn(METHODNAME +  'error : ' + resp.error );

                    this.setState({ 
                        dimmerEliminarRac : false  
                    });

                }

            }).catch((error) => { 
                console.error(METHODNAME +  'Error al procesar respuesta: ' + error)
                this.setState({ 
                    dimmerEliminarRac : false  
                });
            });

        }).catch((error) => { 
            console.error(METHODNAME +  'Server Error: ' + error)
        });

        return json;

    }

    nuevaPlantilla(){
        console.log( 'nuevaPlantilla - INI '); 
        //PARA MODAL DE PLANTILLA 

        this.setState({ 
            error2 : '' ,
            tempPlantilla : emptyPlantilla ,
            showModalPlantillaEdit : true ,
        });
        this.state.tempPlantilla.resolucionRac.resolucionRacId = this.state.resolucionRac.resolucionRacId ; 
    }

    async editarPlantilla( resolucionRacPlantillaId ){
        let METHODNAME = 'editarPlantilla - ';
        console.log( METHODNAME + 'INI '); 
        
        this.setState({ 
            error2 : '' ,
            tempPlantilla : emptyPlantilla
        });

        let url =  `${server}/resolucionRacPlantilla/` + resolucionRacPlantillaId;

        const json = await fetch( url , {
            method: 'GET',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            }
        }).then((result) => {
            
            result.json().then((resp) => {
                
                if( resp.plantilla ){

                    this.setState({
                        tempPlantilla : resp.plantilla , 
                        showModalPlantillaEdit : true 
                    }); 
                    
                }else{
                    console.warn(METHODNAME +  'No se pudo obtener la informacion de la plantilla ' ); 
                }

            }).catch((error) => { 
                console.error(METHODNAME +  'Error al procesar respuesta: ' + error)
            });

        }).catch((error) => { 
            console.error(METHODNAME +  'Server Error: ' + error)
        });
        return json;
    }

    async eliminarPlantilla( resolucionRacPlantillaId ){
        let METHODNAME = 'eliminarPlantilla - ';
        console.log( METHODNAME + 'INI ');

        this.setState({ 
            error2 : '' 
        });
   
        let url =  `${server}/resolucionRacPlantilla/`+resolucionRacPlantillaId;

        const json = await fetch( url , {
            method: 'DELETE',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            } 
        }).then((result) => {
            console.log(METHODNAME + 'RESPUESTA OBTENIDA');
            result.json().then((resp) => {

                if( resp.resultado === 'true' ){
                    console.warn(METHODNAME +  'eliminado correctamente.' );

                    this.verPlantillas( this.state.tempPlantilla.resolucionRac.resolucionRacId );
                    
                    //grabado correctamente
                    this.setShowModalPlantillaEdit(false);
                }else{
                    console.warn(METHODNAME +  'No se pudo eliminar ' );
                    console.warn(METHODNAME +  'error : ' + resp.error );
                    this.setState({ 
                        error2 : resp.error 
                    }); 
                }

            }).catch((error) => { 
                console.error(METHODNAME +  'Error al procesar respuesta: ' + error)
            });

        }).catch((error) => { 
            console.error(METHODNAME +  'Server Error: ' + error)
        });

        return json;

    }

    async registrarPlantilla(){
        let METHODNAME = 'registrarPlantilla - ';
        console.log( METHODNAME + 'INI ');
  
        let dataForm = null;
        dataForm = {
            plantilla : this.state.tempPlantilla 
        }

        let url =  `${server}/resolucionRacPlantilla/`;

        const json = await fetch( url , {
            method: 'POST',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            },
            body:JSON.stringify(dataForm)
        }).then((result) => {
            console.log(METHODNAME + 'RESPUESTA OBTENIDA');
            result.json().then((resp) => {

                if( resp.resultado === 'true' ){
                    console.warn(METHODNAME +  'grabado correctamente' );
                    
                    this.verPlantillas( this.state.tempPlantilla.resolucionRac.resolucionRacId );
                    
                    //grabado correctamente
                    this.setShowModalPlantillaEdit(false);
                }else{
                    console.warn(METHODNAME +  'No se pudo grabar la informacion' );
                    console.error(METHODNAME +  'error : ' + resp.error );
                    this.setState({ 
                        error2 : resp.error 
                    }); 
                }

            }).catch((error) => { 
                console.error(METHODNAME +  'Error al procesar respuesta: ' + error)
            });

        }).catch((error) => { 
            console.error(METHODNAME +  'Server Error: ' + error)
        });

        return json;
    }
    
    cargarWord( resolucionRacPlantillaId ){
        let METHODNAME = 'cargarWord - ';
        console.log( METHODNAME + 'INI ');

        console.log( METHODNAME + 'resolucionRacPlantillaId =  ' + resolucionRacPlantillaId );
        
        this.setState({
            resolucionRacPlantillaId_word : resolucionRacPlantillaId , 
            showModalWord : true ,
            up_file : null ,
            up_fileName : '',
        }); 
 
    }
            
    onFormSubmit = e => {
        e.preventDefault(); // Stop form submit
        console.log("form submit");
        if( this.state.up_file ){
            this.fileUpload(this.state.up_file);
        }else{
            alert('seleccione un archivo');
        }
        
    };

    fileChange = e => {
        console.log("fileChange  - INI");

        this.setState({ 
            up_file: e.target.files[0], 
            up_fileName: e.target.files[0].name 
            },
            () => {
                console.log( "Archivo seleccionado --->", this.state.up_file, "nombre del archivo  --->", this.state.up_fileName );
            }
        );
    };

    fileUpload = async file => {
        let METHODNAME = 'fileUpload - ';
        console.log(METHODNAME + "INI");

        const dataForm = new FormData();
        dataForm.append("file", file); 

        let url = `${server}/resolucionRacPlantilla/${this.state.resolucionRacPlantillaId_word}/upload`;

        await fetch( url , {
            method: 'POST',
            headers:{
                'Accept':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            },
            body:dataForm
        }).then((result) => {
            console.log(METHODNAME + 'RESPUESTA OBTENIDA');
            result.json().then((resp) => {

                if( resp.resultado === 'true' ){
                    console.warn(METHODNAME +  'grabado correctamente' );
                    
                    this.setState({
                        resolucionRacPlantillaId_word : null , 
                        showModalWord : false 
                    }); 
                    this.verPlantillas( this.state.resolucionRac.resolucionRacId );
                    
                }else{
                    console.warn(METHODNAME +  'No se pudo grabar la informacion' );
                    console.warn(METHODNAME +  'error : ' + resp.error );
                    this.setState({
                        resolucionRacPlantillaId_word : null , 
                        showModalWord : false ,
                        error2 : resp.error ,
                    }); 
                }

            }).catch((error) => { 
                console.error(METHODNAME +  'Error al procesar respuesta: ' + error)
            });

        }).catch((error) => { 
            console.error(METHODNAME +  'Server Error: ' + error)
        });
        
    };
    
    setShowModalEdit( mostrar ){
        this.setState({
            showModalEdit: mostrar
        });
    }

    setShowPanelPlantillas( mostrar ){
        this.setState({
            showPanelPlantillas: mostrar
        });
    }
    
    setShowModalPlantillaEdit( mostrar ){
        this.setState({
            showModalPlantillaEdit: mostrar
        });
    }

    setShowModalWord( mostrar ){
        this.setState({
           showModalWord: mostrar
        });
    }
      
    handleChange = input => event => {      
        this.setState(prevState => ({
            tempPlantilla:{
              ...prevState.tempPlantilla,
              [input]: event.target.value
            }
        }));
    }

    handleChangeBoolean( name , mostrar ){
        this.setState({
            [name]: mostrar
        });
    }

    _handlerChangeTextResolucionObject( e ){        

        let valor = e.target.value;
        let name = e.target.name;

        this.setState(prevState => ({
            tempResolucionRac:{
              ...prevState.tempResolucionRac,
              [name]: valor
            }
        }));

    }

    _onChangeSelectResolucionObject(e, { name, value }) {
        this.setState(prevState => ({
            tempResolucionRac:{
              ...prevState.tempResolucionRac,
              [name]: value
            }
        }));
    }

  render() {

    const { error, isLoaded, listaResolucionRac , pregunta , listaPlantillas , error2 , mensaje } = this.state;

    if (error) {
        return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
        return <div>Loading...</div>;
    } else {

            return(
                <div>
            <Container>

                <Header as='h2' content='Resultados para Pregunta' className='h2' textAlign='center' />

                { error2 &&
                    <Message
                        color='red'
                        onDismiss={ () => this.handleDismiss('error2')}
                        header='Ha ocurrido un error:'
                        content={error2}
                    />
                }

                { mensaje &&
                    <Message
                        color='green'
                        onDismiss={ () => this.handleDismiss('mensaje')}
                        header='Resultado satisfactorio:'
                        content={mensaje}
                    />
                }
                
                <Segment>
                    <Grid columns={2} stackable> 
                        <Grid.Row >
                            <Grid.Column width={3}>
                                <label style={ {'fontWeight' : 'bold'}}>Pregunta:</label>
                            </Grid.Column>
                            <Grid.Column width={13}>
                                {pregunta.nombrePregunta}<br/>
                                <div dangerouslySetInnerHTML={{__html:pregunta.explicacionPregunta}} /> 
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row >
                            <Grid.Column width={3}>
                                <label style={ {'fontWeight' : 'bold'}}>Alternativas:</label>
                            </Grid.Column>
                            <Grid.Column width={13}>
                                {pregunta.alternativas &&
                                    pregunta.alternativas.map(item => ( 
                                    <label>
                                    { (item.alternativaPadreId == null && item.estado > 0) &&
                                        <div> 
                                                {item.posicion + ') '} 
                                                {item.label} 
                                                {item.resolucionRacId?'(tiene Resultado asociado)':''}
                                        </div>
                                    }
                                    </label>
                                ))}
                            </Grid.Column>
                        </Grid.Row>

                        <Grid.Row >
                            <Grid.Column width={3}>
                                <label style={ {'fontWeight' : 'bold'}}>Tipo de Pregunta:</label>
                            </Grid.Column>
                            <Grid.Column width={13}>
                                {pregunta.tipoPregunta.nombre}
                            </Grid.Column>
                        </Grid.Row>

                    </Grid>
                </Segment>

                <Segment>

                <div>
                    <Button onClick={ () => this.nuevoResultado()}
                            color='green' size='tiny' >
                        <Icon name="save" />
                        Agregar nuevo resultado
                    </Button>
                </div>
            
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan='6' textAlign='center'>Resultados agregados</Table.HeaderCell>
                        </Table.Row>
                        <Table.Row key='head0001'> 
                            <Table.HeaderCell>Asociado a:</Table.HeaderCell>
                            <Table.HeaderCell>Tipo de Resultado</Table.HeaderCell>
                            <Table.HeaderCell>
                                Consecuencia
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Resultado recomendado según alternativa seleccionada'
                                    inverted
                                    />
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Motivo
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Explicación del resultado recomendado'
                                    inverted
                                    />
                            </Table.HeaderCell>
                            <Table.HeaderCell>Tipo de Rechazo</Table.HeaderCell> 
                            <Table.HeaderCell>Estado</Table.HeaderCell>
                            <Table.HeaderCell>Acciones</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
            
                    <Table.Body>
                        
                        { listaResolucionRac && listaResolucionRac.map(resultado => (
                            <Table.Row key={resultado.resolucionRacId}>
                                <Table.Cell>{resultado.preguntaId?'Pregunta':'Alternativa'}</Table.Cell>
                                <Table.Cell>{resultado.tipoResultado?resultado.tipoResultado.nombre:''}</Table.Cell>
                                <Table.Cell>{resultado.consecuencia} </Table.Cell> 
                                <Table.Cell>{resultado.motivo}</Table.Cell>
                                <Table.Cell>{resultado.tipoRechazoDesc}</Table.Cell>
                                <Table.Cell>{resultado.estadoTxt}</Table.Cell>
                                <Table.Cell> 
                                    
                                    <Button color='blue' animated="vertical" size='mini' 
                                            onClick={ () => this.editarResolucionRac(resultado.resolucionRacId)}  >
                                        <Button.Content visible>
                                            <Icon name="edit outline" />
                                        </Button.Content>
                                        <Button.Content hidden>
                                            Editar
                                        </Button.Content>
                                    </Button>

                                    <Button color='orange' animated="vertical" size='mini'
                                            onClick={ () => this.verPlantillas(resultado.resolucionRacId)}  >
                                        <Button.Content visible>
                                            <Icon name="eye" />
                                        </Button.Content>
                                        <Button.Content hidden>
                                            Plantillas
                                        </Button.Content>
                                    </Button>

                                    <Button color='red' animated="vertical" size='mini'
                                            onClick={ () => this.preEeliminarResolucionRac(resultado.resolucionRacId)}  >
                                        <Button.Content visible>
                                            <Icon name="trash alternate outline" />
                                        </Button.Content>
                                        <Button.Content hidden>
                                            Eliminar
                                        </Button.Content>
                                    </Button>

                                </Table.Cell>
                            </Table.Row>
                        ))}

                    </Table.Body>
            
                </Table>
                </Segment>             

                { this.state.showPanelPlantillas ? 
            
                <Segment>
                     
                    <div>

                        <Button onClick={ () => this.setShowPanelPlantillas( false )}
                                color='orange' size='tiny' >
                            <Icon name="angle double up" />
                            Cerrar</Button>
 
                        <Button onClick={ () => this.nuevaPlantilla()}
                                color='green' size='tiny' >
                            <Icon name="save" />
                            Agregar nueva plantilla</Button>                 
                    </div>

                    <Table celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan='5' textAlign='center'>Plantillas agregadas</Table.HeaderCell>
                            </Table.Row>
                            <Table.Row key='head0002'> 
                                <Table.HeaderCell>Num. Expediente</Table.HeaderCell>
                                <Table.HeaderCell>Nombre del archivo</Table.HeaderCell>
                                <Table.HeaderCell>Link pdf TC</Table.HeaderCell>
                                <Table.HeaderCell>Criterio del Tribunal</Table.HeaderCell> 
                                <Table.HeaderCell>Acciones</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                
                        <Table.Body>
                            { listaPlantillas && listaPlantillas.map(plantilla => (
                                <Table.Row key={plantilla.resolucionRacPlantillaId}>
                                    <Table.Cell>{plantilla.codigo} </Table.Cell> 
                                    <Table.Cell>{plantilla.nombre ? plantilla.nombre : ''}</Table.Cell>
                                    <Table.Cell>
                                        {plantilla.link ? 
                                            <a href={plantilla.link} target='_blank' rel="noreferrer"> {plantilla.codigo} </a> 
                                            : '' 
                                        }
                                    </Table.Cell>
                                    <Table.Cell> 
                                        {plantilla.tienePlantillaDocx === 1 ? 
                                            <a href={ serverPu + '/dwnPlantilla?id='+plantilla.resolucionRacPlantillaId} target='_blank' rel="noreferrer"> {plantilla.codigo} </a>
                                            : '--'}
                                    </Table.Cell> 
                                    <Table.Cell> 
                                        
                                        <Button color='blue' animated="vertical" size='mini' 
                                                onClick={ () => this.editarPlantilla(plantilla.resolucionRacPlantillaId)}  >
                                            <Button.Content visible>
                                                <Icon name="edit outline" />
                                            </Button.Content>
                                            <Button.Content hidden>
                                                Editar
                                            </Button.Content>
                                        </Button>

                                        <Button color='red' animated="vertical"  size='mini'
                                                onClick={ () => this.eliminarPlantilla(plantilla.resolucionRacPlantillaId)}  >
                                            <Button.Content visible>
                                                <Icon name="trash alternate outline" />
                                            </Button.Content>
                                            <Button.Content hidden>
                                                Eliminar
                                            </Button.Content>
                                        </Button>

                                        <Button color='teal' animated="vertical" size='mini'
                                                onClick={ () => this.cargarWord( plantilla.resolucionRacPlantillaId )}  >
                                            <Button.Content visible>
                                                <Icon name="upload" />
                                            </Button.Content>
                                            <Button.Content hidden>
                                                Cargar
                                            </Button.Content>
                                        </Button>

                                    </Table.Cell>
                                </Table.Row>
                            ))}

                        </Table.Body>

                    </Table>
                    
                </Segment>                
            
                : null }
            
                <Link to={`/baseDeConocimientos` }>
                    <Button primary >
                        <Icon name="reply" />Volver  
                    </Button>
                </Link>

            </Container>

            <Confirm
                open={this.state.confirmEliminarRacOpen}
                header='Eliminar Registro'
                content='¿Está seguro que desea eliminar el registro seleccionado?'
                onCancel={ () => this.handleChangeBoolean('confirmEliminarRacOpen', false )} 
                onConfirm={this.eliminarResolucionRac}
            />

            <Dimmer active={this.state.dimmerEliminarRac} inverted >
                <Loader>Loading</Loader>
            </Dimmer>
            
            <Modal
                closeIcon
                closeOnEscape={false}
                onClose={() => this.setShowModalEdit(false)} 
                open={this.state.showModalEdit}
            >
            <Modal.Header>Agregar Resultado</Modal.Header>
            <Modal.Content>
                 
                <Modal.Description>
                    <Grid columns={2} >

                    <Grid.Row>
                            <Grid.Column width={4}>
                                Alternativa
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Opcional. el resultado aplicara unicamente al seleccionar esta alternativa'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column>
                                <Dropdown
                                        placeholder='Seleccionar alternativa' 
                                        fluid
                                        selection
                                        clearable
                                        options={this.state.optlistaAlternativas}
                                        id='tempAlternativaId'
                                        name='tempAlternativaId'
                                        value={this.state.tempResolucionRac.tempAlternativaId}  
                                        onChange={this._onChangeSelectResolucionObject}  
                                    />
                            </Grid.Column>
                        </Grid.Row> 

                        <Grid.Row>
                            <Grid.Column width={4}>
                                Tipo de Resultado:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Tipo del resultado. Se compara contra el campo Rechazo Inmediato de la Alternativa. Si no selecciona nada, el Tipo de Rechazo a seleccionar debe ser Verdadero o Falso'
                                    inverted
                                    />

                            </Grid.Column>
                            <Grid.Column>
                                
                                <Dropdown
                                        placeholder='Seleccionar' 
                                        fluid
                                        selection
                                        options={tipoResultadoOption}
                                        id='tipoResultado'
                                        name='tipoResultado'
                                        value={this.state.tempResolucionRac.tipoResultado} 
                                        onChange={this._onChangeSelectResolucionObject}  
                                    />

                            </Grid.Column>
                        </Grid.Row> 

                        <Grid.Row>
                            <Grid.Column width={4}>
                                Consecuencia:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Texto de consecuencia'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column>
                                <Input placeholder='consecuencia...'  fluid
                                    id='consecuencia' name='consecuencia'
                                    value={this.state.tempResolucionRac.consecuencia} 
                                    onChange = {this._handlerChangeTextResolucionObject}/>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={4}>
                                Motivo:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Texto del motivo'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column>
                                <Input placeholder='motivo...' fluid
                                    id='motivo' name='motivo'
                                    value={this.state.tempResolucionRac.motivo} 
                                    onChange = {this._handlerChangeTextResolucionObject}/>
                            </Grid.Column>
                        </Grid.Row> 

                        <Grid.Row>
                            <Grid.Column width={4}>
                                Modelo:
                            </Grid.Column>
                            <Grid.Column>
                                <Input placeholder='modelo...' fluid
                                    id='modelo' name='modelo'
                                    value={this.state.tempResolucionRac.modelo} 
                                    onChange = {this._handlerChangeTextResolucionObject}/>
                            </Grid.Column>
                        </Grid.Row>

                        <Grid.Row>
                            <Grid.Column width={4}>
                                Tipo de Rechazo:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Tipo de rechazo'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column>
                                    <Dropdown
                                        placeholder='Seleccionar'
                                        fluid
                                        selection
                                        id='tipoRechazo'
                                        name='tipoRechazo'
                                        value={this.state.tempResolucionRac.tipoRechazo} 
                                        options={tipoRechazoOption}
                                        onChange={this._onChangeSelectResolucionObject}  
                                    />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Description>

            </Modal.Content>
            <Modal.Actions>
                <Button color='red' onClick={() => this.setShowModalEdit(false)}>
                    Cancelar
                </Button>
                <Button
                    content="Regsitrar"
                    labelPosition='right'
                    icon='checkmark'
                    onClick={() => this.registrarResultado(false)}
                    positive
                />
            </Modal.Actions>
            </Modal>

            <Modal
                closeIcon
                closeOnEscape={false}
                onClose={() => this.setShowModalPlantillaEdit(false)} 
                open={this.state.showModalPlantillaEdit}
            >
                <Modal.Header>Datos de Plantilla</Modal.Header>
                <Modal.Content>
                <Modal.Description>
                    <Grid columns={2} >
                    
                        <Grid.Row>
                            <Grid.Column width={4}>
                                Número de Expediente:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Número del Expediente al cual corresponde la plantilla'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column>
                                <Input placeholder='numero expediente...' 
                                    onChange={this.handleChange('codigo')}
                                    value={this.state.tempPlantilla.codigo}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={4}>
                                Nombre del archivo:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Nombre que lleva el archivo y con el cual se va a descargar'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column>
                                <Input placeholder='nombre...' 
                                    onChange={this.handleChange('nombre')}
                                    value={this.state.tempPlantilla.nombre}
                                    />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={4}>
                                Link pdf del TC:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Enlace a sistema del TC en donde ver / descargar la Resolución de ejemplo'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column>
                                <Input placeholder='enlace PDF......' 
                                    onChange={this.handleChange('link')}
                                    value={this.state.tempPlantilla.link}
                                    />
                            </Grid.Column>
                        </Grid.Row>

                    </Grid>
                    </Modal.Description>

                </Modal.Content>

                <Modal.Actions>
                    <Button color='red' onClick={() => this.setShowModalPlantillaEdit(false)}>
                        Cancelar
                    </Button>
                    <Button
                        content="Regsitrar"
                        labelPosition='right'
                        icon='checkmark'
                        onClick={() => this.registrarPlantilla()}
                        positive
                    /> 
                </Modal.Actions>
            </Modal>
            
            <Modal
                closeIcon
                closeOnEscape={false}
                as={Form}
                onSubmit={this.onFormSubmit}
                onClose={() => this.setShowModalWord(false)} 
                open={this.state.showModalWord}
            >
                <Modal.Header>Plantilla Word con ponencia recomendada</Modal.Header>

                <Modal.Content>

                <Modal.Description>
                 
                    <Form.Field>
                        
                        <Button as="label" htmlFor="file" type="button" animated="fade" color='teal'>
                            <Button.Content visible>
                                <Icon name="file outline" />
                            </Button.Content>
                            <Button.Content hidden>Seleccionar archivo</Button.Content>
                        </Button>

                        <input
                            type="file"
                            id="file"
                            hidden
                            onChange={this.fileChange}
                            accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        />
                        <Form.Input
                            fluid
                            label="Archivo seleccionado: "
                            placeholder="Usar el botón superior para buscar el archivo en su computadora"
                            readOnly
                            value={this.state.up_fileName}
                        /> 
                        {this.state.up_statusCode && this.state.up_statusCode === 200 ? (
                        <Progress
                            style={{ marginTop: "20px" }}
                            percent={100}
                            success
                            progress
                        >
                            Carga satisfactoria
                        </Progress>
                        ) : this.state.up_statusCode && this.state.up_statusCode === 500 ? (
                        <Progress
                            style={{ marginTop: "20px" }}
                            percent={100}
                            error
                            active
                            progress
                        >
                           Falló la carga 
                        </Progress>
                        ) : null}
                    </Form.Field>
                    
                </Modal.Description>

                </Modal.Content>
          
                <Modal.Actions>
                    <Button color='blue' onClick={() => this.setShowModalWord(false)}>
                        Cancelar
                    </Button>
                    <Button negative
                            style={{ marginTop: "20px" }} 
                            type="submit"
                            content="Cargar archivo"
                            labelPosition='right'
                            icon='checkmark'/> 
                </Modal.Actions>

            </Modal>

            </div>
            );

        }
    }

}

export default WrappedResultados